module.exports = __webpack_public_path__ + "static/media/selected.fd60581e.svg";